import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  QCProcessForm,
  type QCProcessFormPrefill,
} from "./QCProcessForm";
import type { QCProcessFormValues } from "@/lib/schemas/qc";

export interface QCProcessModalContainerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: QCProcessFormValues) => Promise<void> | void;
  initialData?: any;
  isSubmitting?: boolean;
  prefill?: QCProcessFormPrefill;
  title?: string;
  description?: string;
}

export function QCProcessModalContainer({
  open,
  onOpenChange,
  onSubmit,
  initialData,
  isSubmitting = false,
  prefill,
  title,
  description,
}: QCProcessModalContainerProps) {
  const isEditMode = !!initialData?.id;

  const defaultTitle =
    title ||
    (isEditMode
      ? "Cập Nhật Biên Bản Kiểm Tra Công Đoạn (IPQC)"
      : "Lập Biên Bản Kiểm Tra Công Đoạn Sản Xuất (IPQC)");

  const defaultDescription =
    description ||
    "Ghi nhận kiểm soát chất lượng quá trình (Nghiệm thu đầu ca, kiểm tra định kỳ, tuần tra xưởng)";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[95vw] lg:max-w-5xl max-h-[92vh] p-0 flex flex-col bg-slate-50 overflow-hidden shadow-2xl">
        <DialogHeader className="p-5 border-b border-slate-200 bg-white sticky top-0 z-10">
          <DialogTitle className="text-lg font-bold text-slate-900 flex items-center gap-2">
            {defaultTitle}
          </DialogTitle>
          <DialogDescription className="text-xs text-slate-500">
            {defaultDescription}
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto p-6">
          <QCProcessForm
            initialData={initialData}
            onSubmit={async (data) => {
              await onSubmit(data);
              onOpenChange(false);
            }}
            onCancel={() => onOpenChange(false)}
            isSubmitting={isSubmitting}
            isDrawerMode={true}
            prefill={prefill}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
